// src/constants/colors.js
/*
const COLORS = [
    "#FFCD00", "#003CA6", "#837902", "#6EC4E8", "#CF009E",
    "#FF7E2E", "#6ECA97", "#FA9ABA", "#6EC4E8", "#E19BDF",
    "#B6BD00", "#C9910D", "#704B1C", "#007852", "#6EC4E8", "#62259D"
].reverse();
*/
/*
export const COLORS = [
  "#FFCD00",
  "#003CA6",
  "#837902",
  "#6EC4E8",
  "#CF009E",
  "#FF7E2E",
  "#6ECA97",
  "#FA9ABA",
  "#E19BDF",
  "#B6BD00",
  "#C9910D",
  "#704B1C",
  "#007852",
  "#62259D",
].reverse();
*/

export const COLORS = [
  //"#FFCD00",
  "#003CA6",
  "#837902",
 // "#6EC4E8",
  "#CF009E",
  "#FF7E2E",
  "#6ECA97",
  //"#FA9ABA",
  "#E19BDF",
  "#B6BD00",
  "#C9910D",
  "#704B1C",
  "#007852",
  "#62259D",
].reverse();


export const COLORS_ALL = [
  "#FFCD00",
  "#003CA6",
  "#837902",
  "#6EC4E8",
  "#CF009E",
  "#FF7E2E",
  "#6ECA97",
  "#FA9ABA",
  "#E19BDF",
  "#B6BD00",
  "#C9910D",
  "#704B1C",
  "#007852",
  "#62259D",
].reverse();


export const COLORS_LIGHT = [
  //"#FFCD00",
  //"#003CA6",
  "#837902",
  //"#6EC4E8",
  "#CF009E",
  "#FF7E2E",
  "#6ECA97",
  //"#FA9ABA",
  //"#E19BDF",
  "#B6BD00",
  "#C9910D",
  //"#704B1C",
  //"#007852",
  "#62259D",
].reverse();
